import themeUtils from '../themeUtils';
import MasonryGrid from './MasonryGrid';

export default class ProductMasonry {
  constructor(component) {
    this.$window = $(window);
    this.$el = $(component.el);
    this.selectors = {
      gallery: {
        el: '[data-masonry-gallery]',
        itemSelector: '.product-image',
        columnWidth: '[data-masonry-image-sizer]',
      },
      relatedProducts: {
        el: '[data-masonry-products]',
        itemSelector: '.product-list-item',
        columnWidth: '[data-masonry-products-sizer]',
      },
    };

    this.masonry = {
      gallery: null,
      relatedProducts: null,
    };

    this.flickity = {
      gallery: null,
      relatedProducts: null,
    };

    this.$gallery = $(this.selectors.gallery.el, this.$el);
    this.$relatedProducts = $(this.selectors.relatedProducts.el, this.$el);

    this.hasGallery = this.$gallery.length;
    this.hasRelatedProducts = this.$relatedProducts.length;

    this._initLayout = this._initLayout.bind(this);

    this._bindEvents();
    this._initLayout();
  }

  remove() {
    this.$window.off('resize.product-masonry-layout');
    this.$gallery.off('product-masonry-layout');
    this.$relatedProducts.off('product-masonry-layout');
    this.$el.off('rimg:load.product-masonry-layout');

    if (this.flickity) {
      this._destroyFlickity();
    }

    if (this.masonry) {
      this._destroyMasonry();
    }
  }

  onSectionUnload() {
    this.remove();
  }

  _bindEvents() {
    this.$window.on('resize.product-masonry-layout', themeUtils.debounce(this._initLayout, 100));
    this.$el.on('rimg:load.product-masonry-layout', () => {
      if (this.flickity.gallery) {
        themeUtils.flickityResize(this.flickity.gallery);
      }

      if (this.flickity.relatedProducts) {
        themeUtils.flickityResize(this.flickity.relatedProducts);
      }
    });
  }

  _initLayout() {
    if (themeUtils.isSmall()) {
      this._initMobile();
    } else {
      this._initDesktop();
    }
  }

  _initMobile() {
    this._destroyMasonry();
    this._initFlickity();
  }

  _initDesktop() {
    this._destroyFlickity();
    this._initMasonry();
  }

  _initFlickity() {
    if (this.hasGallery && !this.flickity.gallery) {
      this._galleryReset();

      this.flickity.gallery = new Flickity(this.$gallery[0], {
        cellAlign: 'left',
        cellSelector: this.selectors.gallery.itemSelector,
        contain: false,
        percentPosition: false,
        prevNextButtons: false,
        pageDots: false,
        setGallerySize: false,
      });

      this._flickityEvents({
        $el: this.$gallery,
        flickity: this.flickity.gallery,
      });
    }

    if (this.hasRelatedProducts && !this.flickity.relatedProducts) {
      this._relatedProductsReset();

      this.flickity.relatedProducts = new Flickity(this.$relatedProducts[0], {
        cellAlign: 'left',
        cellSelector: this.selectors.relatedProducts.itemSelector,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        setGallerySize: false,
      });

      this._flickityEvents({
        $el: this.$relatedProducts,
        flickity: this.flickity.relatedProducts,
      });
    }
  }

  _destroyFlickity() {
    if (this.flickity.gallery) {
      this.flickity.gallery.destroy();
      this.flickity.gallery = null;

      this.$window.off('resize.product-images-flickity');
    }

    if (this.flickity.relatedProducts) {
      this.flickity.relatedProducts.destroy();
      this.flickity.relatedProducts = null;
    }
  }

  _initMasonry() {
    if (this.hasGallery && !this.masonry.gallery) {
      this._galleryReset();
      this.masonry.gallery = new MasonryGrid({
        $el: this.$gallery,
        settings: {
          itemSelector: this.selectors.gallery.itemSelector,
          columnWidth: this.selectors.gallery.columnWidth,
        },
      });
    }

    if (this.hasRelatedProducts && !this.masonry.relatedProducts) {
      this._relatedProductsReset();

      this.masonry.relatedProducts = new MasonryGrid({
        $el: this.$relatedProducts,
        settings: {
          itemSelector: this.selectors.relatedProducts.itemSelector,
          columnWidth: this.selectors.relatedProducts.columnWidth,
        },
      });
    }
  }

  _destroyMasonry() {
    if (this.masonry.gallery) {
      this.masonry.gallery.unload();
      this.masonry.gallery = null;
    }

    if (this.masonry.relatedProducts) {
      this.masonry.relatedProducts.unload();
      this.masonry.relatedProducts = null;
    }
  }

  _galleryReset() {
    this.$gallery.find(this.selectors.gallery.itemSelector).attr('style', '');
  }

  _relatedProductsReset() {
    this.$relatedProducts.find(this.selectors.relatedProducts.itemSelector).attr('style', '');
  }

  _flickityEvents(options) {
    const { $el, flickity } = options;

    flickity.on('cellSelect', () => $el.trigger('product-masonry-layout'));

    flickity.on('settle', () => $el.trigger('product-masonry-layout'));

    $el.on('product-masonry-layout', () => themeUtils.flickityResize(flickity));

    // Sets the Slider to the height of the first slide
    $el.trigger('product-masonry-layout');

    this.$window.on(
      'resize.product-images-flickity',
      themeUtils.debounce(() => $el.trigger('product-masonry-layout'), 10),
    );
  }
}
